<template>
  <div class="modal-overlay">
    <div class="modal-content unsub">
      <div class="close-btn" id="closeModalBtn">
        <img src="/static/images/x.svg">
      </div>

      <div class="modal-card">
        <div class="content">
          <h1>{{ getTranslations.home_modals_unsubscribe_title }}</h1>

          <p>
            <span>{{ userDetails.username }}</span>,
            {{ getTranslations.home_modals_unsubscribe_user_unsubscribe }}
          </p>

          <p>{{ getTranslations.home_modals_unsubscribe_if_you_unsubscribe }}</p>

          <h2>{{ getTranslations.home_modals_unsubscribe_continue_message }}</h2>

          <base-button container-class="blue unsub_btn" @button:click="unsubscribe">
            {{ getTranslations.home_modals_unsubscribe_confirm_button }}
          </base-button>
        </div>
      </div>

      <div class="outer-modal-card">
        <base-button container-class="cancel" button-class="fancy_btn close_modal">
          {{ getTranslations.home_modals_unsubscribe_cancel_button }}
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations, mapState} from 'vuex'
import BaseButton from '../../common/button/BaseButton'
import Resubscribe from './Resubscribe'
import ResubscribeGameSms from './ResubscribeGameSms'
import modals from '../../../common/modals'

export default {
  name: 'unsubscribe',
  components: {
    BaseButton,
    Resubscribe,
    ResubscribeGameSms
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForSettings'
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails'
    ]),
    ...mapActions('common', [
      'optoutCall'
    ]),
    noUnSubscribe () {
      modals.hideModal(this)
    },
    unsubscribe () {
      this.optoutCall().then(() => {
        this.getUserLoginDetails().then(() => {
          if (this.userDetails.subscribed) {
            modals.hideCommonModal({
              afterHideCallback: () => {
                this.storeModalForSettings(null)
              }
            })
          } else {
            if (this.subAndUnsubViaSMS && (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS')) {
              this.storeModalForSettings(ResubscribeGameSms)
            } else {
              this.storeModalForSettings(Resubscribe)
            }
            modals.setupCommonModal({
              afterHideCallback: () => {
                this.storeModalForSettings(null)
              }
            })
          }
        })
      })
    }
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig'
    ]),
    ...mapGetters('i18n', [
      'getTranslations'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/modals/Unsubscribe.vue